import typography from "../typography";
import palette from "../palette";

export default {
  root: {
    ...typography.h4,
    backgroundColor: palette.background.primary,
  },
};
